export const marketApiQueryKeys = {
  all: ['marketApi'] as const,
  status: () => [...marketApiQueryKeys.all, 'status'] as const,
  chain: () => [...marketApiQueryKeys.all, 'chain'] as const,
  pairs: (sort?: string, limit?: number) =>
    [...marketApiQueryKeys.all, 'pairs', sort ?? 'volume24h', limit ?? 100] as const,
  pools: () => [...marketApiQueryKeys.all, 'pools'] as const,
  poolsMetrics: () => [...marketApiQueryKeys.all, 'poolsMetrics'] as const,
  tokenCatalog: (chainId: number) => [...marketApiQueryKeys.all, 'tokenCatalog', chainId] as const,
  pairCatalog: (chainId: number) => [...marketApiQueryKeys.all, 'pairCatalog', chainId] as const,
  walletPermissions: (address: string) =>
    [...marketApiQueryKeys.all, 'walletPermissions', address.toLowerCase()] as const,
  poolById: (id: string) => [...marketApiQueryKeys.all, 'pool', id] as const,
  pair: (pairAddress: string) => [...marketApiQueryKeys.all, 'pair', pairAddress] as const,
  tokenProfile: (address: string) => [...marketApiQueryKeys.all, 'tokenProfile', address] as const,
  tokenStats: (address: string) => [...marketApiQueryKeys.all, 'tokenStats', address] as const,
  ohlcv: (pairAddress: string, interval: string, limit?: number) =>
    [...marketApiQueryKeys.all, 'ohlcv', pairAddress, interval, limit ?? 200] as const,
  trades: (pairAddress: string, limit?: number) =>
    [...marketApiQueryKeys.all, 'trades', pairAddress, limit ?? 50] as const,
  depth: (pairAddress: string, levels?: number) =>
    [...marketApiQueryKeys.all, 'depth', pairAddress, levels ?? 12] as const,
  portfolio: (wallet: string) => [...marketApiQueryKeys.all, 'portfolio', wallet] as const,
}
